import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { MyEInvoiceTinUpdateRequestHdrContainerModel } from '../../../../../models/aggregates/e-invoice/my_einvoice_tin_update_request_hdr_container.model';
import { ApiResponseModel, ApiVisa } from '../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class MyEInvoiceTinUpdateRequestHdrService extends BaseApiPublicLoginTemplateService<MyEInvoiceTinUpdateRequestHdrContainerModel, MyEInvoiceTinUpdateRequestHdrContainerModel, MyEInvoiceTinUpdateRequestHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-hdrs/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-hdrs/' + BaseApiTemplateService.BACKOFFICE_EP
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-hdrs/' + BaseApiTemplateService.BACKOFFICE_EP
    this.httpClient = http;
  }

  uploadCsv(dtoObject: FormData, visa: ApiVisa): Observable<ApiResponseModel<MyEInvoiceTinUpdateRequestHdrContainerModel>> {
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-hdrs/upload-csv/' + BaseApiTemplateService.BACKOFFICE_EP
    let endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/tin-update-request-hdrs/upload-csv/' + BaseApiTemplateService.BACKOFFICE_EP
    if (visa.api_domain_url) {
      apiUrl = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<MyEInvoiceTinUpdateRequestHdrContainerModel>>(
      apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
